import { defineMessages } from 'react-intl';

export default defineMessages({
    taxInstructions: {
        id: 'agent.registration.views.taxInstructions',
        defaultMessage: 'All the steps required to register with TWIA must be completed during one internet session, including clicking “Submit” on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TWIA.',
    },
    taxtfpaInstructions: {
        id: 'agent.registration.views.taxtfpaInstructions',
        defaultMessage: 'All the steps required to register with TFPA must be completed during one internet session, including clicking “Submit” on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TFPA.',
    },
    confirmBackupWithholding: {
        id: 'agent.registration.views.confirmBackupWithholding',
        defaultMessage: 'I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding'
    },
    confirmCitizenship: {
        id: 'agent.registration.views.confirmCitizenship',
        defaultMessage: 'I am a U.S. citizen or other U.S. person (defined below)'
    },
    confirmTIN: {
        id: 'agent.registration.views.confirmTIN',
        defaultMessage: 'The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me)'
    },
    confirmFacta: {
        id: 'agent.registration.views.confirmFacta',
        defaultMessage: 'The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct'
    },
    taxInformationLegal: {
        id: 'agent.registration.views.taxInformationLegal',
        defaultMessage: 'Section 6109 of the Internal Revenue Code requires you to provide your correct TIN to persons (including federal agencies) who are required to file information returns with the IRS to report interest, dividends, or certain other income paid to you; mortgage interest you paid; the acquisition or abandonment of secured property; the cancellation of debt; or contributions you made to an IRA, Archer MSA, or HSA. The person collecting this form uses the information on the form to file information returns with the IRS, reporting the above information. Routine uses of this information include giving it to the Department of Justice for civil and criminal litigation and to cities, states, the District of Columbia, and U.S. commonwealths and possessions for use in administering their laws. The information also may be disclosed to other countries under a treaty, to federal and state agencies to enforce civil and criminal laws, or to federal law enforcement and intelligence agencies to combat terrorism. You must provide your TIN whether or not you are required to file a tax return. Under section 3406, payers must generally withhold a percentage of taxable interest, dividend, and certain other payments to a payee who does not give a TIN to the payer. Certain penalties may also apply for providing false or fraudulent information.'
    },
    tINInstructions: {
        id: 'agent.registration.views.tINInstructions',
        defaultMessage: 'Enter your TIN in the appropriate box. The TIN provided must match the name given to avoid backup withholding.'
    },
    certificationlegalText: {
        id: 'agent.registration.views.certificationlegalText',
        defaultMessage: 'Under penalties of perjury, I certify that:'
    },
    w9Link: {
        id: 'agent.registration.views.w9Link',
        defaultMessage: 'Link to IRS W-9 Form:'
    },
    exemptions: {
        id: 'agent.registration.views.exemptions',
        defaultMessage: 'Exemptions (codes apply only to certain entities, not individuals)'
    },
    twia1099Address: {
        id: 'agent.registration.views.twia1099Address',
        defaultMessage: 'Agent 1099 forms will be sent to this address. If necessary, please update the Mailing Address on the Agency Information screen.'
    },
    address: {
        id: 'agent.registration.views.Address',
        defaultMessage: 'Address'
     },
     addressLine1: {
        id: 'agent.registration.views.Address Line 1',
        defaultMessage: 'Address Line 1'
     },
    taxName: {
        id: 'agent.registration.views.taxName',
        defaultMessage: 'Name (as shown in your income tax returns)'
    },
    businessName: {
        id: 'agent.registration.views.businessName',
        defaultMessage: 'Business Name/Disregarded Entity Name (if different from above)'
    },
    federalTax: {
        id: 'agent.registration.views.federalTax',
        defaultMessage: 'Federal Tax Classification'
    },
    classificationCode: {
        id: 'agent.registration.views.classificationCode',
        defaultMessage: 'Classification Code'
    },
    pleaseSpecify: {
        id: 'agent.registration.views.pleaseSpecify',
        defaultMessage: 'Please Specify'
    },
    exemptPayee: {
        id: 'agent.registration.views.exemptPayee',
        defaultMessage: 'Exempt Payee Code (if any)'
    },
    SSN: {
        id: 'agent.registration.views.TaxSSN',
        defaultMessage: 'Social Security Number (SSN)'
    },
    SSNValidationMessage: {
        id: 'agent.registration.views.SSNValidationMessage',
        defaultMessage: 'Enter a valid SSN.'
    },
    EINValidationMessage: {
        id: 'agent.registration.views.EINValidationMessage',
        defaultMessage: 'Enter a valid EIN.'
    },    
    EIN: {
        id: 'agent.registration.views.TaxEIN',
        defaultMessage: 'Employer Identification Number (EIN)'
    },
    TIN: {
        id: 'agent.registration.views.TIN',
        defaultMessage: 'Taxpayer Identification Number (TIN)'
    },
    taxInformation: {
        id: 'agent.registration.views.taxInformation',
        defaultMessage: 'Tax Information'
    },
    tinNotification: {
        "id": "agent.registration.views.TINNotification",
        "defaultMessage": "Enter either an SSN or EIN."  
    }
});